'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var LEFT_PAGE = 'LEFT';
var RIGHT_PAGE = 'RIGHT';

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, _class);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.range = function (from, to) {
      var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var i = from;
      var range = [];

      while (i <= to) {
        range.push(i);
        i += step;
      }

      return range;
    }, _this.getPageNumbers = function () {
      var _this$props = _this.props,
          activePage = _this$props.activePage,
          pageNeighbours = _this$props.pageNeighbours;
      var totalPages = _this.props.pages;
      var currentPage = activePage;
      var totalNumbers = pageNeighbours * 2 + 3;
      var totalBlocks = totalNumbers + 2;

      if (totalPages > totalBlocks) {
        var startPage = Math.max(2, currentPage - pageNeighbours);
        var endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);

        var pages = _this.range(startPage, endPage);

        var hasLeftSpill = startPage > 2;
        var hasRightSpill = totalPages - endPage > 1;
        var spillOffset = totalNumbers - (pages.length + 1);
        var extraPages = void 0;

        switch (true) {
          case hasLeftSpill && !hasRightSpill:
            {
              extraPages = _this.range(startPage - spillOffset, startPage - 1);
              pages = [LEFT_PAGE].concat(_toConsumableArray(extraPages), _toConsumableArray(pages));
              break;
            }

          case !hasLeftSpill && hasRightSpill:
            {
              extraPages = _this.range(endPage + 1, endPage + spillOffset);
              pages = [].concat(_toConsumableArray(pages), _toConsumableArray(extraPages), [RIGHT_PAGE]);
              break;
            }

          case hasLeftSpill && hasRightSpill:
          default:
            {
              pages = [LEFT_PAGE].concat(_toConsumableArray(pages), [RIGHT_PAGE]);
              break;
            }
        }

        return [1].concat(_toConsumableArray(pages), [totalPages]);
      }

      return _this.range(1, totalPages);
    }, _this.render = function () {
      var _this$props2 = _this.props,
          activePage = _this$props2.activePage,
          prev = _this$props2.prev,
          next = _this$props2.next,
          onSelect = _this$props2.onSelect,
          pages = _this$props2.pages;

      var pageNumbers = _this.getPageNumbers(); // If there are no or 1 page, don't print a pager.


      if (pages <= 1) {
        return null;
      }

      return _react2.default.createElement('nav', {
        'aria-label': 'Page navigation'
      }, _react2.default.createElement('ul', {
        className: 'pagination'
      }, _react2.default.createElement('li', {
        className: 'page-item ' + (activePage === 1 ? 'disabled' : '')
      }, _react2.default.createElement('span', {
        className: 'page-link',
        style: {
          cursor: 'pointer'
        },
        onClick: function onClick() {
          activePage !== 1 ? onSelect(activePage - 1) : null;
        }
      }, prev)), pageNumbers.map(function (page, pageNumber) {
        var className = page === activePage ? 'active' : '';

        if (page === LEFT_PAGE) {
          return _react2.default.createElement('li', {
            className: 'page-item disabled'
          }, _react2.default.createElement('span', {
            className: 'page-link',
            style: {
              cursor: 'pointer'
            }
          }, _react2.default.createElement('span', {
            'aria-hidden': 'true'
          }, '...')));
        }

        if (page === RIGHT_PAGE) {
          return _react2.default.createElement('li', {
            className: 'page-item disabled'
          }, _react2.default.createElement('span', {
            className: 'page-link',
            style: {
              cursor: 'pointer'
            }
          }, _react2.default.createElement('span', {
            'aria-hidden': 'true'
          }, '...')));
        }

        return _react2.default.createElement('li', {
          className: 'page-item ' + className,
          key: pageNumber
        }, _react2.default.createElement('span', {
          className: 'page-link',
          onClick: function onClick() {
            return onSelect(page);
          },
          style: {
            cursor: 'pointer'
          }
        }, page));
      }), _react2.default.createElement('li', {
        className: 'page-item ' + (activePage === pages ? 'disabled' : '')
      }, _react2.default.createElement('span', {
        className: 'page-link',
        style: {
          cursor: 'pointer'
        },
        onClick: function onClick() {
          activePage !== pages ? onSelect(activePage + 1) : null;
        }
      }, next))));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return _class;
}(_react.Component);

_class.propTypes = {
  pages: _propTypes2.default.number.isRequired,
  pageNeighbours: _propTypes2.default.number,
  activePage: _propTypes2.default.number,
  prev: _propTypes2.default.string,
  next: _propTypes2.default.string,
  onSelect: _propTypes2.default.func.isRequired
};
_class.defaultProps = {
  pages: 1,
  pageNeighbours: 1,
  activePage: 1,
  prev: 'Previous',
  next: 'Next',
  onSelect: function onSelect() {}
};
exports.default = _class;